import { FileUploadButton, ImageDropzone } from 'react-file-utils';
import {
  Tooltip,
  UploadsPreview,
  useChannelStateContext,
  useMessageInputContext,
  useTranslationContext,
} from 'stream-chat-react';
import { ReactComponent as ImageSvg } from '../../images/image.svg';
import { mixTrack } from '@services/mixpanel';

export const CustomMessageInput = () => {
  const { acceptedFiles, multipleUploads, quotedMessage } =
    useChannelStateContext('MessageInputFlat');
  const { t } = useTranslationContext('MessageInputFlat');

  const {
    cooldownRemaining,
    handleSubmit,
    isUploadEnabled,
    attachments,
    maxFilesLeft,
    numberOfUploads,
    text,
    setText,
    uploadNewFiles,
  } = useMessageInputContext('MessageInputFlat');

  return (
    <div className="p-3">
      <ImageDropzone
        accept={acceptedFiles}
        disabled={!isUploadEnabled || maxFilesLeft === 0 || !!cooldownRemaining}
        handleFiles={uploadNewFiles}
        maxNumberOfFiles={maxFilesLeft}
        multiple={multipleUploads}
      >
        {quotedMessage?.text}
        <div className="str-chat__input-flat-wrapper">
          <div className="str-chat__input-flat--textarea-wrapper">
            {isUploadEnabled && <UploadsPreview />}
            {isUploadEnabled && !cooldownRemaining && (
              <div
                className="str-chat__fileupload-wrapper"
                data-testid="fileinput"
              >
                <Tooltip>
                  {maxFilesLeft
                    ? (t('Attach files') as string)
                    : (t(
                        "You've reached the maximum number of files",
                      ) as string)}
                </Tooltip>
              </div>
            )}
            <div className="w-full rounded-2xl bg-gray-100 px-4 py-2 flex gap-2 items-center justify-between">
              <FileUploadButton
                accepts={acceptedFiles}
                disabled={maxFilesLeft === 0}
                handleFiles={uploadNewFiles}
                multiple={multipleUploads}
              >
                <div className="p-2 rounded-full bg-primary ml-[-1px]">
                  <ImageSvg className="fill-white" style={{ height: '12px' }} />
                </div>
              </FileUploadButton>
              <div className="w-full flex-1">
                <input
                  className="bg-transparent border-none w-full ml-1"
                  value={text}
                  onKeyPress={(event) => {
                    if (event.key === 'Enter') {
                      handleSubmit(event);
                      mixTrack({
                        // @ts-ignore
                        type: 'Chat Message Sent',
                        payload: {
                          'DM Type': 'text',
                        },
                      });
                    }
                  }}
                  onChange={(e) => setText(e.target.value)}
                  placeholder="Message..."
                />
              </div>
              {(text || numberOfUploads > 0) && (
                <button
                  type="submit"
                  className="text-primary font-semibold"
                  onClick={handleSubmit}
                >
                  Send
                </button>
              )}
            </div>
          </div>
          {/* {!cooldownRemaining && <SendButton sendMessage={handleSubmit} />} */}
        </div>
      </ImageDropzone>
    </div>
  );
};
